module.exports = __webpack_public_path__ + "img/m-start-menu-desktop.9a469522.png";